/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type OrgSettingsPutVideoLayout = typeof OrgSettingsPutVideoLayout[keyof typeof OrgSettingsPutVideoLayout] | null;


export const OrgSettingsPutVideoLayout = {
  speaker: 'speaker',
  gallery: 'gallery',
  audio_only: 'audio_only',
} as const;
